export function addRecaptchaToken(form) {
    const tokenInput = form.querySelector('#recaptchaToken') || form.querySelector('[name="recaptcha_token"]');

    // Récupérer l'action depuis l'attribut data-action du formulaire
    const action = form.dataset.action || 'submit';

    // Récupérer la clé depuis l'attribut data-site-key
    const recaptchaScript = document.querySelector('script[src*="recaptcha/enterprise.js"]');
    const siteKey = recaptchaScript?.dataset.siteKey;

    if (typeof grecaptcha === 'undefined' || !siteKey) {
        console.error('Le système de vérification n\'est pas disponible.');
        return false;
    }

    grecaptcha.enterprise.ready(function() {
        grecaptcha.enterprise.execute(siteKey, {action: action})
            .then(function(token) {
                tokenInput.value = token;
                form.submit();
            })
            .catch(function() {
                console.error('Erreur lors de la vérification.');
            });
    });

    return false; // Empêche la soumission immédiate du formulaire
}
